import { IFilter } from 'components/Filters';
import capitalizeFirstLetter from 'utils/capitalizeFirstLetter';

const generateFilterData = <T extends { [key: string]: string | undefined }>(
  filterTitle: keyof T,
  filterValues: Array<{ title: string }>,
): IFilter<T> => (
    {
      key: filterTitle,
      label: capitalizeFirstLetter(filterTitle as string),
      allLabel: `All ${capitalizeFirstLetter(filterTitle as string)}`,
      values: filterValues.map((item) => ({
        value: item.title,
        label: item.title,
      })),
    }
  );

export default generateFilterData;
